import { LearnedPresetKind } from "@redotech/redo-fulfillment-outbound-labels-common/outbound-label-enums";
import * as zExt from "@redotech/rpc/ext";
import { privacy } from "@redotech/schema-privacy";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";
import { PresetSchema } from "./presets";

const LearnedPresetOutputSchema = PresetSchema.omit({
  _id: true,
  name: true,
  hotkey: true,
});
export type LearnedPresetOutput = z.infer<typeof LearnedPresetOutputSchema>;

export const LearnedPresetSchema = z.object({
  kind: createEnum(LearnedPresetKind, { enumName: "LearnedPresetKind" }).meta({
    privacy: privacy.nonPii,
  }),
  preset: LearnedPresetOutputSchema.meta({ privacy: privacy.structured }),
  key: z.string().meta({ privacy: privacy.nonPii }),
  learnedFrom: zExt.objectId().meta({ privacy: privacy.nonPii }),
});
export type LearnedPreset = z.infer<typeof LearnedPresetSchema>;

export const LearnedPresetDocumentSchema = z.object({
  _id: zExt.objectId().meta({ privacy: privacy.nonPii }),
  preset: LearnedPresetSchema.meta({ privacy: privacy.structured }),
  team: zExt.objectId().meta({ privacy: privacy.nonPii }),
  createdAt: z.date().meta({ privacy: privacy.nonPii }),
  updatedAt: z.date().meta({ privacy: privacy.nonPii }),
});
export type LearnedPresetDocument = z.infer<typeof LearnedPresetDocumentSchema>;
